import axios from "../axiosConfig";
import { currentLanguage } from "../../algorithms/storage";

export const addTask = (data, token) => {
  return axios.post(`Task/AddTask`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateTask = (data, token) => {
  return axios.post(`Task/UpdateTask`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addAttachment = (
  taskId,
  procedureId,
  activityId,
  activityProcId,
  projectId,
  subTaskId,
  subProcedureId,
  data,
  token,
) => {
  if (taskId != null)
    return axios.post(`Task/AddTaskAttachment/${taskId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  else if (activityId != null)
    return axios.post(`Activity/AddActivityAttachment/${activityId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  else if (activityProcId != null)
    return axios.post(
      `Activity/AddActivityProcedureAttachment/${activityProcId}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": currentLanguage(),
          Authorization: `Bearer ${token}`,
        },
      },
    );
  else if (projectId != null)
    return axios.post(`Project/AddProjectAttachment/${projectId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  else if (subTaskId != null)
    return axios.post(`SubTask/AddSubTaskAttachment/${subTaskId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  else if (subProcedureId != null)
    return axios.post(
      `SubTaskProcedure/AddSubTaskProcedureAttachment/${subProcedureId}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Accept-Language": currentLanguage(),
          Authorization: `Bearer ${token}`,
        },
      },
    );
  else
    return axios.post(`Task/AddProcedureAttachment/${procedureId}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
};

export const getTaskForm = (communityID, token) => {
  return axios.get(`Task/GetTaskForm/${communityID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTaskSearchForm = (communityID, token) => {
  return axios.get(`Task/GetTaskFormSearch/${communityID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getEditTaskForm = (taskID, communityID, token) => {
  return axios.get(`Task/GetEditTaskForm/${taskID}/${communityID}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAllTasks = (
  communityID,
  userID,
  pageNumber = 1,
  pageSize = 20,
  token,
) => {
  return axios.get(
    `Task/GetAllWithProcedure/${communityID}/${userID}/${pageNumber}/${pageSize}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const getTask = (taskId, token) => {
  return axios.get(`Task/Details/${taskId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSubTasks = (taskId, token) => {
  return axios.post(
    `SubTask/SearchStatusCount/${taskId}`,
    {},
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const getSubTask = (subTaskId, token) => {
  return axios.get(`SubTask/Details/${subTaskId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTaskAttachments = (
  taskId,
  pageNo = 1,
  pageCount = 10,
  token,
) => {
  return axios.get(
    `Task/GetAllTaskAttachment/${taskId}/${pageNo}/${pageCount}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const getSubTaskAttachments = (
  subTaskId,
  pageNo = 1,
  pageCount = 10,
  token,
) => {
  return axios.get(
    `SubTask/GetAllSubTaskAttachment/${subTaskId}/${pageNo}/${pageCount}`,
    {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const getTaskMembers = (taskId, token) => {
  return axios.get(`Task/GetTaskMember/${taskId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTaskStatus = (token) => {
  return axios.get("Task/GetTaskStatus", {
    headers: {
      Authorization: `Bearer ${token}`,
      "Accept-Language": currentLanguage(),
    },
  });
};

export const setStatus = (memberId, statusId, token) => {
  return axios.put(`Task/SetMemberStatus/${memberId}/${statusId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      // Authorization: `Bearer ${token}`,
    },
  });
};

export const setTasksStatus = (taskId, statusId, cahngeAll, token) => {
  return axios.put(`Task/SetTaskStatus/${taskId}/${statusId}/${cahngeAll}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      // Authorization: `Bearer ${token}`,
    },
  });
};

export const searchTasks = (
  communityID,
  pageNumber = 1,
  pageSize = 20,
  data = {},
  token,
) => {
  return axios.post(
    `Task/Search/${communityID}/${pageNumber}/${pageSize}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    },
  );
};

export const searchTaskStatusCount = (communityID, data = {}, token) => {
  return axios.post(`Task/SearchAccessLevelCount/${communityID}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const delTask = (taskId, token) => {
  return axios.delete(`Task/DeleteTask/${taskId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

//subtasks
export const delSubTask = (subTaskId, token) => {
  return axios.delete(`SubTask/DeleteSubTask/${subTaskId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const delSubTaskProc = (subTaskId, token) => {
  return axios.delete(`SubTaskProcedure/DeleteSubTaskProcedure/${subTaskId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSubTaskEdit = (subTaskId, communityId, token) => {
  return axios.get(`SubTask/Details/${subTaskId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

// export const updateSubTask = (data, communityId, token) => {
//   return axios.put(`SubTask/UpdateSubTask?communityId=${communityId}`, data, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       "Accept-Language": currentLanguage(),
//       Authorization: `Bearer ${token}`,
//     },
//   });
// };
export const updateSubTask = (data, communityId, token) => {
  return axios.post(`SubTask/UpdateTask`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getSubTaskAdd = (communityId, token) => {
  return axios.get(`SubTask/GetSubTaskForm/${communityId}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addSubTask = (data, token) => {
  return axios.post(`SubTask/AddSubTask`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
